import { useQuery } from 'react-query';
import { UIUserAssessment } from '../../../../../packages/types/src/userAssessment';
import { getUserAssessmentSubmission, getUserAssessmentSubmissionBlockItem } from '../../apis/V2/assessment';

export const useAssessmentSubmission = (publishedItemId?: string) => {
	return useQuery({
		queryKey: ['useAssessmentSubmission', publishedItemId],
		queryFn: async () => (await getUserAssessmentSubmission({ publishedItemId }))?.data as any,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!publishedItemId,
	});
};

export const useAssessmentSubmissionBlockItem = (blockItemId?: string) => {
	return useQuery({
		queryKey: ['useAssessmentSubmissionBlockItem', blockItemId],
		queryFn: async () => (await getUserAssessmentSubmissionBlockItem({ blockItemId })).data as UIUserAssessment,
		staleTime: 60000,
		retry: false,
		refetchOnWindowFocus: false,
		enabled: !!blockItemId,
	});
};
